module.exports = __webpack_public_path__ + "img/2.33f3b21c.png";